import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-barcode-read-icon',
  templateUrl: './shopping-barcode-read.component.html'
})
export class ShoppingBarcodeReadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
